import util from '@/api/util';


const apiUrl = util.apiUrl()
export const tabs = [
  {
    title: '面性',
    value: 'facet',
    tabItem: [
      {
        title: '通用(有背景)',
        isDefault: true,
        value: 'facetBg',
        // list: ['userfiles/svgicons/facet-bg/34.svg']
        list: []
      },
      {
        title: '通用(无背景)',
        value: 'facetNoBg',
        isColor: true,
        list: []
      },
      {
        title: '热门(无背景)',
        value: 'popularNoBg',
        isColor: true,
        list: []
      },
      {
        title: '毛玻璃（有背景）',
        value: 'groundBg',
        isColor: true,
        list: []
      },
      {
        title: '毛玻璃（无背景）',
        value: 'groundNoBg',
        isColor: true,
        list: []
      },
      {
        title: '色彩渐变',
        value: 'colorGradient',
        isColor: true,
        list: []
      },
      {
        title: '默认头像',
        value: 'defaultAvatar',
        isColor: true,
        list: []
      },
      {
        title: '扁平头像',
        value: 'flatAvatar',
        isColor: true,
        list: []
      },
      {
        title: '3D头像',
        value: '3dAvatar',
        isColor: true,
        list: []
      }
    ]
  },
  {
    title: '线性',
    value: 'iconly',
    tabItem: [
      {
        title: '通用',
        value: 'iconly',
        isColor: true,
        list: []
      },
      // {
      //   title: '医疗',
      //   value: 'monochrome',
      //   isColor: true,
      //   list: []
      // },
      {
        title: '教育',
        value: 'multicolor',
        isColor: true,
        list: []
      }
    ]
  },
  {
    title: '图标设计',
    value: 'svgicons'
  },
  {
    title: '插画',
    value: 'illustration',
    tabItem: [
      {
        title: '通用',
        value: 'common',
        list: []
      },
      {
        title: '空状态插画',
        value: 'void',
        list: []
      },
      {
        title: '场景插画',
        value: 'screen',
        list: []
      },
      {
        title: '轻质感图标',
        value: 'light',
        list: []
      },
      {
        title: '扁平图标',
        value: 'flat',
        list: []
      },
      {
        title: 'C4D图标',
        value: 'c4d',
        list: []
      },
      {
        title: '毛玻璃质感',
        value: 'groundGlass',
        list: []
      },
    ]
  },
  {
    title: '自定义上传',
    value: 'custom',
    tabItem: [
      {
        title: '图标',
        value: 'icon',
        noShow: false,
        type: 1,
        list: []

      },
      {
        title: '插画',
        value: 'book',
        type: 2,
        list: [],
        noShow: true
      }
    ]
  }
  // {
  //   title: '设置',
  //   value: 'setting',
  //   tabItem: [
  //     {
  //       title: '设置',
  //       value: 'set',

  //     },
  //   ]
  // }
]

export const iconColor = [
  'default',
  'rgba(5, 126, 255, 1)',
  'rgba(47, 5, 235, 1)',
  'rgba(255, 109, 5, 1)',
  'rgba(255, 51, 5, 1)',
  'rgba(219, 0, 205, 1)',
  'rgba(147, 5, 255, 1)',
  'rgba(255, 187, 0, 1)',
  'rgba(41, 189, 30, 1)'
]


export const convertImgToSvg = async (urlList = []) => {
  return new Promise((resolve, reject) => {
    // 只处理 SVG 图片
    const fnLi = []
    for (const ele of urlList) {
      const imgURL = apiUrl + '/' + ele.url
      const fn = () => {
        return new Promise((resolve) => {
          if (!imgURL.endsWith('.svg')) return
          fetch(imgURL)
            .then(response => response.text())
            .then(svgContent => {
              resolve({
                url: svgContent
              })
              // console.log(svgContent, 'svgsvgsvg')
              // // 创建一个 div 来解析 SVG 字符串
              // const div = document.createElement('div')
              // div.innerHTML = svgContent
              // // 获取 SVG 元素
              // const svg = div.querySelector('svg')

              // if (svg) {
              // // 保留原 img 的 ID 和 class
              //   if (imgID) svg.id = imgID
              //   // 保留原 img 的其他属性
              //   // for (let i = 0; i < imgElement.attributes.length; i++) {
              //   //   const attr = imgElement.attributes[i]
              //   //   if (attr.name !== 'src' && attr.name !== 'id' && attr.name !== 'class') {
              //   //     svg.setAttribute(attr.name, attr.value)
              //   //   }
              //   // }
              //   const url = svg.outerHTML
              //   resolve({
              //     url
              //   })
              // }
            })
        })
      }
      fnLi.push(fn())
    }
    Promise.all(fnLi).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
